var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customizer-layout-option"},[_c('OptionsCustomizer',{attrs:{"options":_vm.opts,"value":_vm.settings.layout[_vm.category]},on:{"input":function($event){return _vm.updateSettings(("layout." + _vm.category), $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }